module.exports = __webpack_public_path__ + "static/media/agriculture.a3663928.jpg";